<!-- Header -->
<div class="flex flex-row column-gap-2">
  <div class="flex flex-1 flex-column row-gap-2">
    <div class="flex flex-row column-gap-2 align-items-center">
      <i class="w-2rem fs-1_5rem"
      [class]="icon"></i>
      <div class="flex flex-grow-1 w-0">
        <span class="text-lg white-space-nowrap overflow-hidden text-overflow-ellipsis"
          [innerHTML]="label | safeHtml">
        </span>
      </div>
    </div>
    <div class="flex flex-row column-gap-2 align-items-center">
      <div class="w-2rem">
        &nbsp;
      </div>
      <span class="flex flex-grow-1 text-sm uppercase overflow-hidden text-overflow-ellipsis">
        {{ type | translate }}
      </span>
    </div>
  </div>
  <div class="flex align-items-center justify-content-center m-1">
    @if ({
      editPanelOverlay: slideAuthorFacade.editPanelOverlay$ | async
    }; as editPanelOverlayData) {
      @if (editPanelOverlayData.editPanelOverlay === true) {
        <button medsurf-design-input-button
          [id]="'close'"
          [title]="'global.close' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PANEL_BIG_TEXT"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.TIMES"
        (click)="hideEditPanel()"></button>
      }
    }
  </div>
</div>

<!-- Divider -->
<p-divider class="w-full"></p-divider>
